import React, { useEffect, useState } from "react";
import FormInput from "./FormInput";
import Button from "../common/Button";
import useFormValidation from "../../hooks/useFormValidation";
import "./ContactForm.css";

const validateForm = (values) => {
  const errors = {};

  // Name validation
  if (!values.name.trim()) {
    errors.name = "Name is required";
  } else if (!/^[A-Za-z\s]+$/.test(values.name.trim())) {
    errors.name = "Name must contain only letters";
  }

  // Email validation
  if (!values.email.trim()) {
    errors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) {
    errors.email = "Invalid email address";
  }

  // Phone validation
  if (!values.phone.trim()) {
    errors.phone = "Phone number is required";
  } else if (!/^[0-9+\-\s()]+$/.test(values.phone.trim())) {
    errors.phone =
      "Phone number can contain numbers, +, -, spaces, and parentheses";
  }

  // Message validation
  if (!values.message.trim()) {
    errors.message = "Message is required";
  } else if (values.message.trim().length < 10) {
    errors.message = "Message must be at least 10 characters";
  }

  return errors;
};

const ContactForm = () => {
  const [submitStatus, setSubmitStatus] = useState({
    type: "",
    message: "",
  });

  const initialState = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  };

  const onSubmit = async (values) => {
    try {
      // Replace this with your actual form submission/API request.
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setSubmitStatus({
        type: "success",
        message:
          "Thank you! Your message has been sent successfully. We will get back to you soon.",
      });

      resetForm();
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message: "Something went wrong. Please try again later.",
      });
    }
  };

  const {
    values,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormValidation(initialState, validateForm);

  useEffect(() => {
    if (!submitStatus.message) return;

    const timer = setTimeout(() => {
      setSubmitStatus({
        type: "",
        message: "",
      });
    }, 5000);

    return () => clearTimeout(timer);
  }, [submitStatus.message]);

  return (
    <>
      {submitStatus.message && (
        <div className={`alert alert-${submitStatus.type}`} role="alert">
          {submitStatus.message}
        </div>
      )}

      <form
        className="contact-form"
        onSubmit={(event) => handleSubmit(event, onSubmit)}
        noValidate
      >
        <div className="form-row">
          <FormInput
            label="Name"
            type="text"
            name="name"
            value={values.name}
            onChange={handleChange}
            error={errors.name}
            required
            placeholder="Your full name"
            autoComplete="name"
          />

          <FormInput
            label="Email"
            type="email"
            name="email"
            value={values.email}
            onChange={handleChange}
            error={errors.email}
            required
            placeholder="your.email@example.com"
            autoComplete="email"
          />
        </div>

        <div className="form-row">
          <FormInput
            label="Phone"
            type="tel"
            name="phone"
            value={values.phone}
            onChange={handleChange}
            error={errors.phone}
            required
            placeholder="Your phone number"
            autoComplete="tel"
          />

          <FormInput
            label="Subject"
            type="text"
            name="subject"
            value={values.subject}
            onChange={handleChange}
            placeholder="How can we help you?"
          />
        </div>

        <FormInput
          label="Message"
          type="textarea"
          name="message"
          value={values.message}
          onChange={handleChange}
          error={errors.message}
          required
          placeholder="Tell us about your project..."
          rows={6}
        />

        <div className="form-actions">
          <Button
            type="submit"
            variant="primary"
            size="large"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send Message"}
          </Button>
        </div>
      </form>
    </>
  );
};

export default ContactForm;
